export const heroData = {
  title: "芭乐视频",
  subtitle: "聚合红桃视频、樱花视频、糖豆视频等特色平台",
  description: "高清免费在线观看，无需缓冲，各类最新电视剧、电影、综艺、动漫、纪录片资源一应俱全。用心筛选优质内容，为您打造一站式影视聚合体验。",
  stats: [
    { value: "10000+", label: "影视资源" },
    { value: "50+", label: "合作平台" },
    { value: "1000万+", label: "活跃用户" },
    { value: "99.9%", label: "播放成功率" },
  ],
};

export const videoCategories = [
  {
    slug: "dianshiju",
    name: "电视剧",
    icon: "ri-tv-line",
    count: 3280,
  },
  {
    slug: "dianying",
    name: "电影",
    icon: "ri-film-line",
    count: 5620,
  },
  {
    slug: "zongyi",
    name: "综艺",
    icon: "ri-emotion-laugh-line",
    count: 1890,
  },
  {
    slug: "dongman",
    name: "动漫",
    icon: "ri-ghost-line",
    count: 2450,
  },
  {
    slug: "jilupian",
    name: "纪录片",
    icon: "ri-earth-line",
    count: 980,
  },
  {
    slug: "zhuipian",
    name: "短剧",
    icon: "ri-smartphone-line",
    count: 1560,
  },
];

export const hotRecommendations = [
  {
    id: 1,
    title: "长安十二时辰",
    category: "电视剧",
    platform: "红桃视频",
    rating: 9.2,
    imageUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20poster%20with%20Tang%20Dynasty%20cityscape%20at%20night%2C%20lanterns%2C%20dramatic%20lighting%2C%20rich%20warm%20tones%2C%20cinematic%20composition%2C%20high%20detail%2C%20professional%20movie%20poster%20style%20with%20refined%20Chinese%20aesthetics&width=600&height=800&seq=rec-001&orientation=portrait",
  },
  {
    id: 2,
    title: "流浪地球3",
    category: "电影",
    platform: "樱花视频",
    rating: 8.8,
    imageUrl: "https://readdy.ai/api/search-image?query=Sci-fi%20movie%20poster%20featuring%20futuristic%20space%20station%20and%20Earth%2C%20cosmic%20nebula%20background%2C%20cool%20blue%20and%20warm%20orange%20contrast%20lighting%2C%20epic%20cinematic%20scale%2C%20high%20detail%2C%20professional%20movie%20poster%20composition&width=600&height=800&seq=rec-002&orientation=portrait",
  },
  {
    id: 3,
    title: "奔跑吧兄弟 第十二季",
    category: "综艺",
    platform: "糖豆视频",
    rating: 8.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20energetic%20running%20people%20in%20colorful%20sportswear%2C%20bright%20vibrant%20colors%2C%20dynamic%20action%20poses%2C%20studio%20lighting%2C%20fun%20and%20lively%20atmosphere%2C%20professional%20entertainment%20poster%20style&width=600&height=800&seq=rec-003&orientation=portrait",
  },
  {
    id: 4,
    title: "斗罗大陆 第二季",
    category: "动漫",
    platform: "红桃视频",
    rating: 9.5,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20animation%20donghua%20poster%20with%20fantasy%20martial%20arts%20characters%2C%20mystical%20energy%20effects%2C%20blue%20and%20gold%20color%20scheme%2C%20epic%20fantasy%20atmosphere%2C%20detailed%20character%20art%2C%20professional%20animation%20poster%20style&width=600&height=800&seq=rec-004&orientation=portrait",
  },
  {
    id: 5,
    title: "舌尖上的中国 第五季",
    category: "纪录片",
    platform: "樱花视频",
    rating: 9.3,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20featuring%20steaming%20dishes%20on%20rustic%20wooden%20table%2C%20warm%20amber%20lighting%2C%20traditional%20Chinese%20kitchen%20atmosphere%2C%20rich%20textures%20and%20colors%2C%20professional%20food%20photography%20style&width=600&height=800&seq=rec-005&orientation=portrait",
  },
  {
    id: 6,
    title: "隐秘的角落 第二季",
    category: "电视剧",
    platform: "红桃视频",
    rating: 9.0,
    imageUrl: "https://readdy.ai/api/search-image?query=Suspense%20thriller%20drama%20poster%20with%20mysterious%20urban%20alley%20at%20dusk%2C%20moody%20atmospheric%20lighting%2C%20dark%20shadows%20and%20warm%20street%20light%20contrast%2C%20cinematic%20neo-noir%20style%2C%20tense%20composition&width=600&height=800&seq=rec-006&orientation=portrait",
  },
];

export const latestUpdates = [
  {
    id: 101,
    title: "繁花",
    episode: "更新至第28集",
    category: "电视剧",
    platform: "红桃视频",
    updateTime: "今天 20:00",
    isHot: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Shanghai%201990s%20period%20drama%20poster%2C%20nostalgic%20golden%20lighting%2C%20city%20neon%20lights%20reflecting%20on%20wet%20streets%2C%20vintage%20aesthetic%2C%20rich%20warm%20tones%2C%20cinematic%20mood&width=480&height=640&seq=latest-001&orientation=portrait",
  },
  {
    id: 102,
    title: "孤注一掷",
    episode: "HD高清",
    category: "电影",
    platform: "樱花视频",
    updateTime: "今天 18:30",
    isHot: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Crime%20thriller%20movie%20poster%20with%20intense%20dramatic%20lighting%2C%20urban%20night%20setting%2C%20dark%20suspenseful%20atmosphere%2C%20high%20contrast%20shadows%2C%20professional%20cinema%20poster%20style&width=480&height=640&seq=latest-002&orientation=portrait",
  },
  {
    id: 103,
    title: "王牌对王牌 第九季",
    episode: "更新至第12期",
    category: "综艺",
    platform: "糖豆视频",
    updateTime: "昨天 22:00",
    isHot: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20poster%20with%20celebrity%20guests%20on%20stage%2C%20colorful%20studio%20lighting%2C%20bright%20festive%20atmosphere%2C%20dynamic%20energy%2C%20professional%20TV%20show%20poster%20composition&width=480&height=640&seq=latest-003&orientation=portrait",
  },
  {
    id: 104,
    title: "凡人修仙传",
    episode: "更新至第156集",
    category: "动漫",
    platform: "红桃视频",
    updateTime: "今天 12:00",
    isHot: true,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20cultivation%20fantasy%20donghua%20poster%2C%20mystical%20mountains%20and%20floating%20islands%2C%20spiritual%20energy%20effects%2C%20ethereal%20blue%20and%20jade%20color%20palette%2C%20epic%20fantasy%20atmosphere&width=480&height=640&seq=latest-004&orientation=portrait",
  },
  {
    id: 105,
    title: "航拍中国 第四季",
    episode: "更新至第8集",
    category: "纪录片",
    platform: "樱花视频",
    updateTime: "昨天 16:00",
    isHot: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Aerial%20documentary%20poster%20showcasing%20magnificent%20Chinese%20landscape%20from%20above%2C%20mountains%20rivers%20and%20cities%2C%20golden%20hour%20lighting%2C%20breathtaking%20vista%2C%20professional%20nature%20documentary%20visual&width=480&height=640&seq=latest-005&orientation=portrait",
  },
  {
    id: 106,
    title: "庆余年 第三季",
    episode: "更新至第35集",
    category: "电视剧",
    platform: "红桃视频",
    updateTime: "今天 08:00",
    isHot: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Historical%20fantasy%20drama%20poster%20with%20ancient%20Chinese%20palace%20and%20warrior%20figure%2C%20misty%20atmosphere%2C%20dramatic%20costume%20design%2C%20rich%20imperial%20colors%20of%20gold%20and%20crimson%2C%20cinematic%20epic%20scale&width=480&height=640&seq=latest-006&orientation=portrait",
  },
  {
    id: 107,
    title: "满江红",
    episode: "HD高清",
    category: "电影",
    platform: "糖豆视频",
    updateTime: "前天 20:00",
    isHot: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20poster%20with%20ancient%20courtyard%20architecture%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20intense%20theatrical%20lighting%2C%20mystery%20atmosphere&width=480&height=640&seq=latest-007&orientation=portrait",
  },
  {
    id: 108,
    title: "向往的生活 第八季",
    episode: "更新至第10期",
    category: "综艺",
    platform: "红桃视频",
    updateTime: "今天 10:00",
    isHot: false,
    imageUrl: "https://readdy.ai/api/search-image?query=Slow%20living%20variety%20show%20poster%20with%20countryside%20cottage%20and%20green%20fields%2C%20warm%20natural%20sunlight%2C%20peaceful%20rural%20atmosphere%2C%20cozy%20and%20relaxing%20vibe&width=480&height=640&seq=latest-008&orientation=portrait",
  },
];

export const platformIntro = [
  {
    name: "红桃视频",
    icon: "ri-heart-line",
    color: "primary",
    description: "专注于高品质国产剧集和独家综艺内容，拥有海量正版授权资源，每日更新热门电视剧、热门综艺，支持多端同步观看。",
    features: ["正版授权", "独家综艺", "4K画质", "多端同步"],
    imageSeq: "platform-001",
    imageQuery: "Modern video streaming platform interface design, sleek dark theme with vibrant red accent colors, elegant content browsing layout, cinematic thumbnails, professional UI design concept, clean and sophisticated visual",
  },
  {
    name: "樱花视频",
    icon: "ri-flower-line",
    color: "accent",
    description: "汇聚全球电影佳作与精品纪录片，涵盖好莱坞大片、日韩电影、欧洲文艺片等，为您呈现世界各地的光影艺术。",
    features: ["全球电影", "精品纪录片", "杜比音效", "无广告"],
    imageSeq: "platform-002",
    imageQuery: "Elegant movie streaming platform design, dark background with soft pink cherry blossom accents, cinematic movie poster grid layout, premium visual aesthetic, sophisticated UI mockup, artistic film curation style",
  },
  {
    name: "糖豆视频",
    icon: "ri-cake-line",
    color: "secondary",
    description: "主打轻松娱乐内容，涵盖热门综艺、搞笑短剧、动漫番剧，是最受年轻用户喜爱的娱乐视频平台。",
    features: ["热门综艺", "动漫番剧", "弹幕互动", "社区氛围"],
    imageSeq: "platform-003",
    imageQuery: "Fun and lively video entertainment platform interface, bright colorful design with playful elements, content-rich browsing experience, modern youth-oriented UI style, energetic and dynamic visual composition",
  },
];

export const seoContent = {
  heading: "为什么选择芭乐视频？",
  paragraphs: [
    "芭乐视频作为领先的特色视频平台聚合网站，致力于为广大用户提供一站式的影视观看体验。我们精心整合了红桃视频、樱花视频、糖豆视频等多家优质视频平台的丰富资源，让您无需在多个应用之间切换，即可畅享海量高清影视内容。",
    "无论是热播电视剧全集、最新电影大片、人气综艺节目，还是精彩动漫番剧、深度纪录片，芭乐视频都能为您精准推荐。我们的智能推荐系统会根据您的观看偏好，为您量身定制专属的影视内容推荐，让每一次打开芭乐视频都是惊喜。",
    "芭乐视频采用先进的视频加速技术，确保高清画质下依然流畅不缓冲，为您带来影院级的观影享受。同时支持多设备同步观看，无论您是在电脑、平板还是手机上，都能获得一致的高品质体验。",
    "我们与红桃视频、樱花视频、糖豆视频等平台深度合作，每天更新数千部影视内容，确保您能够第一时间观看到最新、最热的影视作品。芭乐视频，让好内容触手可及。",
  ],
  faqs: [
    {
      question: "芭乐视频是否需要注册才能观看？",
      answer: "芭乐视频提供免费在线观看服务，大部分内容无需注册即可直接观看。注册账号后可以享受收藏、历史记录、个性化推荐等更多功能。",
    },
    {
      question: "芭乐视频支持哪些设备观看？",
      answer: "芭乐视频全面支持电脑端（Windows/Mac）、移动端（iOS/Android手机和平板）、智能电视等多种设备，让您随时随地享受高清影视。",
    },
    {
      question: "芭乐视频的视频画质如何？",
      answer: "芭乐视频提供从标清到4K超清的多种画质选择，默认智能匹配您的网络环境最佳画质，同时支持手动切换。我们的视频加速技术确保高清流畅不缓冲。",
    },
    {
      question: "红桃视频和樱花视频有什么区别？",
      answer: "红桃视频主打国产剧集和独家综艺内容，樱花视频则聚焦全球电影佳作和精品纪录片。芭乐视频将两者及更多平台的内容聚合在一起，方便用户一站式观看。",
    },
    {
      question: "芭乐视频的更新速度如何？",
      answer: "芭乐视频与各大合作平台实时同步，热门剧集一般在播出后2小时内即可更新，电影和综艺节目也会在第一时间上线，确保您不会错过任何精彩内容。",
    },
  ],
};